import axios from 'axios';
import cookie from '../cookieHelper/cookie'; // Assuming you have a cookie helper

export default function getAllCompaniesDetails(status, page, size, nameLike) {
    let queryParams = `?status=${status}&pageNumber=${page}&pageContent=${size}`;

    if (nameLike.length > 0) {
        queryParams += `&nameLike=${nameLike}`;
    }

    const API_URL = `${process.env.REACT_APP_BASE_URL}/api/v1/getCompanies`;

    // Retrieve the authentication token from cookies
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);

    return axios
        .get(API_URL + queryParams, {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        })
        .then(res => {
            if (res.status && res.status == 200) {
                return res.data.data.companies;
            } else {
                return res.data.status.message;
            }
        })
        .catch(err => {
            // console.error('Error fetching company details:', err);
            return err;
        });
}
